module.exports = __webpack_public_path__ + "img/icon_bztb@2x.84f05ba1.png";